import { API } from 'aws-amplify';

const seguroPost = body =>
	API.post('estrella', '/seguro-post', { body });

const getSeguro = async ({ loanId, estudianteId, codeudorId }) =>
	await API.get('estrella', '/seguro', {
		queryStringParameters: { loanId, estudianteId, codeudorId },
	});

const SeguroService = {
	getSeguro,
	seguroPost,
};

export default SeguroService;
